
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing/one/home",
      function () {
        return require("private-next-pages/pricing/one/home.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pricing/one/home"])
      });
    }
  